import { useRef } from 'react'
import { useButton } from '@react-aria/button'
import { useModals } from 'almanac-ui/Modal'
import { ChatGeneratedMediaContent } from 'api/clients/ChatClient'
import { MediaPreviewModal } from './MediaPreviewModal'
import Styles from './GeneratedMediaContent.module.scss'

interface GeneratedMediaContentProps {
  content: ChatGeneratedMediaContent
}

export const GeneratedMediaContent = ({ content }: GeneratedMediaContentProps) => {
  const { openModal } = useModals()
  const ref = useRef<HTMLDivElement>(null)

  const handleOpenPreview = () => {
    openModal(MediaPreviewModal, { content }, { newStack: true })
  }

  const { buttonProps } = useButton({ onPress: handleOpenPreview, elementType: 'div' }, ref)

  return (
    <div className={Styles.mediaPreview} ref={ref} {...buttonProps}>
      {content.type === 'generated_image' ? (
        <img src={content.image_url} alt="AI generated content" />
      ) : (
        <video src={content.video_url} poster={content.thumbnail_url} controls={false} loop muted autoPlay />
      )}
    </div>
  )
}
